import React from "react";
import {
  Button,
  FormFieldSet,
  MailRecipient,
  Modal,
  TableAdv,
  useFormHandler,
} from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const ShareLca = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      comments: "",
      linkValidity: "",
    },
    {
      linkValidity: { type: "select", required: true },
    }
  );

  const columns = [
    {
      key: "lcaNumber",
      label: "LCA Number",
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row.endDate, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
    },
  ];
  const tableData = [
    {
      lcaNumber: "I-200-25071-769090",
      startDate: "2021-09-30T00:00:00.000Z",
      endDate: "2021-09-30T00:00:00.000Z",
      status: "Certified",
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <Modal
      title={"Share LCA"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div>
          <MailRecipient />

          <div className="mt-3 body-two">Subject</div>
          <div className="border-[1px] border-neutral-50 p-4 mt-2">
            <div className="min-h-32">text Editor</div>
            <div>
              <p className="body-two">LCA Details.</p>
              <div className="mt-2">
                <TableAdv
                  tableId={`immigration_lca_sharelca`}
                  rows={mappedRows}
                  columns={columns}
                  showSlNo
                  hideToolBar
                />
              </div>
              <p className="body-two mt-3">
                Please click on the link provided below to view the files.
              </p>
            </div>
            <div className="grid grid-cols-1 max-w-3xl mt-6 gap-y-6">
              <FormFieldSet
                type="textArea"
                title={"Comments"}
                placeholder="Enter "
                value={formData.comments}
                onChange={(value) => handleChange("comments", value)}
                error={errors.comments}
              />
              <FormFieldSet
                type="select"
                title={"Link Validity"}
                placeholder="Select Link Validity"
                value={formData.linkValidity}
                onChange={(value) => handleChange("linkValidity", value)}
                error={errors.linkValidity}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-3 justify-end my-8">
          <Button title="No" variant="outlined" onClick={onClose} />
          <Button title="Yes" onClick={() => {}} />
        </div>
      </div>
    </Modal>
  );
};

export default ShareLca;
